export default "__VITE_ASSET__CyF0KFSF__"